module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (215).73e3c3ab.jpg";